type errorMessageType = {
  [key: string]: string;
};

const errorMessages: errorMessageType = {
  403: "The requested resource cannot be accessed!",
  404: "The server cannot find the requested resource!",
  429: "Too many requests were made to the server! Please try again later.",
  noResponse: "The server is not responding!",
  unexpectedError: "Unexpected error occurred!",
};

export const handleError = (error: any, callback: Function) => {
  if (error.response) {
    const status = error.response.status;
    const errorMessage = errorMessages[status];
    if (errorMessage) {
      callback(errorMessage);
    } else {
      callback(errorMessages.unexpectedError);
    }
  } else if (error.request) {
    callback(errorMessages.noResponse);
  } else {
    callback(errorMessages.unexpectedError);
  }
};

export const handleErrorByStatus = (status: number, callback: Function) => {
  const errorMessage = errorMessages[status];
  if (errorMessage) {
    callback(errorMessage);
  } else {
    callback(errorMessages.unexpectedError);
  }
};
